var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.observeVisibilityOptions,
          expression: "observeVisibilityOptions",
        },
      ],
      staticClass: "home-collections",
    },
    [
      _vm.items.length
        ? _c(
            "segment",
            {
              attrs: { title: _vm.$t("navigation.collections") },
              scopedSlots: _vm._u(
                [
                  {
                    key: "display-options",
                    fn: function () {
                      return [
                        _vm.isIntersectionVisible
                          ? _c(
                              "div",
                              { staticClass: "display-option show-all" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: _vm.getLocalizedSearchRoute(
                                        "Collections"
                                      ),
                                    },
                                  },
                                  [
                                    _c("icon-plus-circle-outline", {
                                      attrs: { title: "" },
                                    }),
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(_vm.$t("common.showAll"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3717521860
              ),
            },
            [
              _c(
                "div",
                { staticClass: "collection-cards is-ancestor" },
                [
                  _vm.isIntersectionVisible
                    ? _c("slick-slides", {
                        attrs: { options: _vm.slickOptions, items: _vm.items },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "slide-card",
                              fn: function (slotScope) {
                                return [
                                  _c("collection-card", {
                                    staticClass: "collection-card",
                                    attrs: {
                                      item: slotScope.item,
                                      resolution: { x: "100vw" },
                                      "image-as-background": true,
                                      social: false,
                                      header: true,
                                      "link-to": true,
                                      contents: false,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          787848343
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.ready && _vm.isIntersectionVisible
                ? _c(
                    "div",
                    { staticClass: "explore" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn black",
                          attrs: {
                            to: _vm.getLocalizedSearchRoute("Collections"),
                          },
                        },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("navigation.searchCollections"))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }